import { motion } from "framer-motion";
import { X, Check } from "lucide-react";

const pains = [
  "Não saber o que postar e travar toda semana",
  "Postar por postar, sem estratégia nem direção",
  "Depender de motivação para manter o ritmo",
  "Não saber como encontrar nem cobrar de clientes",
  "Informação solta que não vira profissão",
];

const wins = [
  "Um caminho claro, do zero ao primeiro cliente",
  "Calendário de conteúdo montado passo a passo",
  "Rotina organizada que não depende de motivação",
  "Método para apresentar seus serviços e cobrar",
  "Exercícios e checklists ao fim de cada capítulo",
];

const fade = {
  hidden: { opacity: 0, y: 40 },
  show: (i) => ({ opacity: 1, y: 0, transition: { duration: 0.7, delay: i * 0.1, ease: [0.16, 1, 0.3, 1] } }),
};

const ProblemSolution = () => (
  <section data-testid="problem-solution-section" className="relative px-6 py-28 sm:py-36 lg:px-12">
    <div className="mx-auto max-w-7xl">
      <motion.p
        className="font-mono-label text-xs uppercase tracking-[0.3em] text-[#D4AF37]"
        variants={fade} initial="hidden" whileInView="show" viewport={{ once: true, margin: "-80px" }} custom={0}
      >
        A realidade do mercado
      </motion.p>
      <motion.h2
        className="font-serif-display mt-6 max-w-3xl text-3xl font-semibold leading-tight text-white sm:text-4xl lg:text-5xl"
        variants={fade} initial="hidden" whileInView="show" viewport={{ once: true, margin: "-80px" }} custom={1}
      >
        O primeiro resultado não vem do melhor plano.
        <span className="italic text-[#D4AF37]"> Vem do plano que foi executado.</span>
      </motion.h2>

      <div className="mt-20 grid grid-cols-1 gap-8 lg:grid-cols-[0.9fr_1.1fr]">
        <motion.div
          data-testid="problem-card"
          className="rounded-2xl border border-[rgba(255,255,255,0.08)] bg-[#121212] p-10 sm:p-12"
          variants={fade} initial="hidden" whileInView="show" viewport={{ once: true, margin: "-80px" }} custom={2}
        >
          <p className="font-mono-label text-[10px] uppercase tracking-[0.3em] text-[#71717A]">Sem método</p>
          <h3 className="font-serif-display mt-4 text-2xl font-semibold text-white sm:text-3xl">A frustração de sempre</h3>
          <ul className="mt-10 space-y-6">
            {pains.map((pain, i) => (
              <li key={i} className="flex items-start gap-4">
                <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full border border-[rgba(255,255,255,0.12)]">
                  <X className="h-3.5 w-3.5 text-[#71717A]" />
                </span>
                <span className="text-sm leading-relaxed text-[#A1A1AA] sm:text-base">{pain}</span>
              </li>
            ))}
          </ul>
        </motion.div>

        <motion.div
          data-testid="solution-card"
          className="relative overflow-hidden rounded-2xl border border-[rgba(212,175,55,0.35)] bg-[#161616] p-10 sm:p-12"
          variants={fade} initial="hidden" whileInView="show" viewport={{ once: true, margin: "-80px" }} custom={3}
        >
          <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(circle_at_80%_0%,rgba(212,175,55,0.12),transparent_55%)]" />
          <p className="font-mono-label text-[10px] uppercase tracking-[0.3em] text-[#D4AF37]">Com Social Media na Prática</p>
          <h3 className="font-serif-display mt-4 text-2xl font-semibold text-white sm:text-3xl">A liberdade de um método</h3>
          <ul className="relative mt-10 space-y-6">
            {wins.map((win, i) => (
              <li key={i} className="flex items-start gap-4">
                <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-[#D4AF37]">
                  <Check className="h-3.5 w-3.5 text-[#0A0A0A]" strokeWidth={3} />
                </span>
                <span className="text-sm leading-relaxed text-white sm:text-base">{win}</span>
              </li>
            ))}
          </ul>
        </motion.div>
      </div>
    </div>
  </section>
);

export default ProblemSolution;
